module.exports = __webpack_public_path__ + "img/QUANTUM FRSOLUTIONS TP old.a1c4029f.png";